module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#technology",
      toString: function () {
        return this.url;
      }
    }